import React from "react";
import { Gauge } from "lucide-react";

const h2 = { margin: 0, fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em", color: "#191c1d", fontFamily: "'Reckless Neue Variable', serif" };

export default function McpManageKey({ catalog }) {
  const open = catalog?.tiers?.open || {};
  return (
    <section id="manage-key" style={{ padding: "48px 24px" }}>
      <div style={{ maxWidth: 860, margin: "0 auto", background: "#fff", border: "1px solid #e8ecee", borderRadius: 16, padding: "22px 24px", display: "flex", gap: 18, flexWrap: "wrap", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ flex: "1 1 420px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
            <Gauge style={{ width: 18, height: 18, color: "#006874" }} />
            <h2 style={{ ...h2, fontSize: 19 }}>Manage your key</h2>
          </div>
          <p style={{ margin: 0, fontSize: 13, color: "#3b494c", lineHeight: 1.7 }}>
            The key portal shows your <strong>usage counters</strong>, the <strong>per-minute and daily quotas</strong> of your tier
            ({open.per_minute}/min · {open.per_day}/day on Open) and lets you <strong>rotate the key</strong> in one click. One active key per account;
            access is granted through a single-use link emailed to the key owner.
          </p>
        </div>
        <a href="/mcp/manage" data-testid="mcp-manage-key-link" style={{ background: "#006874", color: "#fff", borderRadius: 999, padding: "11px 22px", fontSize: 13, fontWeight: 700, textDecoration: "none", whiteSpace: "nowrap" }}>Open the key portal →</a>
      </div>
    </section>
  );
}
